
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{tresRiosInfo.Titulo_Separador_1}}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>

    <div class="container pb-120 gx-5 gx-lg-0 tab-style4">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-3 col-xxl-3 pe-lg-0 px-2 mt-5">
          <!-- start tab navigation -->
          <ul class="nav nav-tabs sticky-lg-top">
            <li class="nav-item color-black">
              <a class="nav-link" href="#tab-tresrios-1" data-bs-toggle="tab" [ngClass]="{active: true}">{{tresRiosInfo.Titulo_Separador_1}}</a>
            </li>
            <li class="nav-item color-black">
              <a class="nav-link" href="#tab-tresrios-2" data-bs-toggle="tab">{{tresRiosInfo.Titulo_Separador_2}}</a>
            </li>
            <li class="nav-item color-black">
              <a class="nav-link" href="#tab-tresrios-3" data-bs-toggle="tab">{{tresRiosInfo.Titulo_Separador_3}}</a>
            </li>
            <li class="nav-item color-black">
              <a class="nav-link" href="#tab-tresrios-4" data-bs-toggle="tab">{{tresRiosInfo.Titulo_Separador_4}}</a>
            </li>
            <li class="nav-item color-black">
              <a class="nav-link" href="#tab-tresrios-5" data-bs-toggle="tab">{{tresRiosInfo.Titulo_Separador_5}}</a>
            </li>
          </ul>
          <!-- end tab navigation -->
        </div>
        <div class="col-12 col-lg-9 col-xxl-7 ps-lg-0 px-2">
          <div class="tab-content">
            <!-- start tab content -->
            <div class="tab-pane p-top-tabs-content" id="tab-tresrios-1" [ngClass]="{active: true}">
              <div class="row align-items-center justify-content-center">
                <div class="col-12">
                  <img alt="Logo Três Rios" src="../../../../assets/img/logos/3Rios_vertical_rgb.svg" class="img-fluid">
                  <p class="mt-40" [innerHTML]="tresRiosInfo.Descricao_Separador_1"></p>
                </div>
              </div>
            </div>
            <!-- end tab content -->
            <!-- start tab content -->
            <div class="tab-pane p-top-tabs-content" id="tab-tresrios-2">
              <div class="row justify-content-center d-flex accordion custom-accordionPlus" *ngFor="let card of cardsInfoShow; let i=index;" [id]="'questoes' + i">
                <div class="col-12 mt-40">
                  <h4 class="text-center">{{card.Nome}}</h4>
                  <p class="text-center" [innerHTML]="card.Descricao"></p>
                  <img alt="Cartão Personalizado Três Rios" src="{{card.Imagem.url}}" class="img-fluid img-cards-tres-rios mx-auto">
                </div>
                <div class="col-12 align-self-center">
                  <div *ngFor="let questao of card.Questoes; let j=index;" class="accordion-item">
                    <h2 class="accordion-header" [id]="'questao-' + i + '-' + j">
                      <button class="accordion-button collapsed" title="Título Pergunta" type="button" aria-expanded="false" data-bs-toggle="collapse"
                              [attr.data-bs-target]="'#resposta-' + i + '-' + j" [attr.aria-controls]="'resposta-' + i + '-' + j" [innerHTML]="questao.Titulo">
                      </button>
                    </h2>
                    <div [id]="'resposta-' + i + '-' + j" class="accordion-collapse collapse" [attr.data-bs-parent]="'#questoes' + i ">
                      <div class="accordion-body">
                        <p class="mt-3" [innerHTML]="questao.Conteudo"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end tab content -->
            <!-- start tab content -->
            <div class="tab-pane p-top-tabs-content" id="tab-tresrios-3">
              <div class="row align-items-center justify-content-center">
                <div class="col-12" [innerHTML]="tresRiosInfo.Descricao_Separador_3">
                </div>
              </div>
            </div>
            <!-- end tab content -->
            <!-- start tab content -->
            <div class="tab-pane p-top-tabs-content" id="tab-tresrios-4">
              <div class="row align-items-center justify-content-center">
                <div class="col-12" [innerHTML]="tresRiosInfo.Descricao_Separador_4">
                </div>
              </div>
            </div>
            <!-- end tab content -->
            <!-- start tab content -->
            <div class="tab-pane p-top-tabs-content" id="tab-tresrios-5">
              <div class="row align-items-center justify-content-center">
                <div class="col-12" [innerHTML]="tresRiosInfo.Descricao_Separador_5">
                </div>
              </div>
            </div>
            <!-- end tab content -->
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

